import { FormattedMessage, useIntl } from 'react-intl';

import { Table, TableColumn } from 'components';

import { ClinicalAssessmentAnswersTableProps } from './types';

import * as S from './styles';

export const ClinicalAssessmentAnswersTable: React.FC<ClinicalAssessmentAnswersTableProps> =
  ({ data }) => {
    const intl = useIntl();
    const AnswersColumn: TableColumn[] = [
      {
        dataKey: 'description',
        key: 'description',
        title: intl.formatMessage({
          id: 'ENDUSER.CLINICALASSESSMENTANSWER.QUESTION',
        }),
        render: value => (
          <S.QuestionDescription>
            <FormattedMessage id={value} />
          </S.QuestionDescription>
        ),
      },
      {
        dataKey: 'answer',
        key: 'answer',
        title: intl.formatMessage({
          id: 'ENDUSER.CLINICALASSESSMENTANSWER.ANSWER',
        }),
        render: value => <FormattedMessage id={value} />,
      },
    ];
    return <Table columns={AnswersColumn} data={data} showHeader={false} />;
  };
